module.exports = __webpack_public_path__ + "img/sec-04-samsung.25455f49.svg";